import { createContext, useContext, useEffect, useState } from "react";

export const UserContext = createContext(null);

export function UserProvider({ children }) {
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const userId = localStorage.getItem("UserId");
        const username = localStorage.getItem("Username");
        const roles = JSON.parse(localStorage.getItem("Roles"));
        const group = localStorage.getItem("Group");

        if (userId) {
            setUser({ userId, username, roles, group });
        } else {
            setUser(null);
        }
        setLoading(false);
    }, []);

    if (loading) {
        return (
            <div style={{ textAlign: "center", marginTop: "40px" }}>
                <div className="spinner"></div>
                <span>Loading...</span>
            </div>
        );
    }

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}